import { ControlPointDuplicate, Delete, Edit } from "@mui/icons-material";
import { IconButton, TableCell } from "@mui/material";
import { QuestionType } from "app/types";
import React from "react";

interface TableCellButtonsProps {
  question: QuestionType;
  onEdit: (question: QuestionType) => void;
  onDelete: (questionId: number) => void;
  translate: (key: string) => string;
  onClone?: (question: QuestionType) => void;
}
const TableCellButtons: React.FC<TableCellButtonsProps> = ({
  onDelete,
  onEdit,
  question,
  translate,
  onClone,
}) => {
  return (
    <TableCell>
      <IconButton
        title={translate("buttons_edit")}
        onClick={() => onEdit(question)}
      >
        <Edit />
      </IconButton>
      <IconButton
        title={translate("deleteRegister_delete")}
        onClick={() => onDelete(question.quizQuestionId)}
      >
        <Delete />
      </IconButton>
      {onClone && (
        <IconButton
          title={translate("buttons_clone")}
          onClick={() => onClone(question)}
        >
          <ControlPointDuplicate />
        </IconButton>
      )}
    </TableCell>
  );
};
export default TableCellButtons;
